export function arrayKeyValueToObject(payload: any[] = []) {
  return payload.reduce((acc, currentValue) => {
    return {
      ...acc,
      [currentValue.name]: currentValue.value,
    }
  }, {})
}
